/** Below are the list of all the keys into various elements of a RJSFSchema or UiSchema that are used by the various
 * utility functions. In addition to those keys, there are the special `ADDITIONAL_PROPERTY_FLAG` and
 * `RJSF_ADDITIONAL_PROPERTIES_FLAG` flags that is added to a schema under certain conditions by the `retrieveSchema()`
 * utility.
 */
export var ADDITIONAL_PROPERTY_FLAG = '__additional_property';
export var ADDITIONAL_PROPERTIES_KEY = 'additionalProperties';
export var ALL_OF_KEY = 'allOf';
export var ANY_OF_KEY = 'anyOf';
export var CONST_KEY = 'const';
export var DEFAULT_KEY = 'default';
export var DEFINITIONS_KEY = 'definitions';
export var DEPENDENCIES_KEY = 'dependencies';
export var ENUM_KEY = 'enum';
export var ERRORS_KEY = '__errors';
export var ID_KEY = '$id';
export var IF_KEY = 'if';
export var ITEMS_KEY = 'items';
export var JUNK_OPTION_ID = '_$junk_option_schema_id$_';
export var NAME_KEY = '$name';
export var ONE_OF_KEY = 'oneOf';
export var PROPERTIES_KEY = 'properties';
export var REQUIRED_KEY = 'required';
export var SUBMIT_BTN_OPTIONS_KEY = 'submitButtonOptions';
export var REF_KEY = '$ref';
/**
 * @deprecated Replace with correctly spelled constant `RJSF_ADDITIONAL_PROPERTIES_FLAG`
 */

export var RJSF_ADDITONAL_PROPERTIES_FLAG = '__rjsf_additionalProperties';
export var RJSF_ADDITIONAL_PROPERTIES_FLAG = '__rjsf_additionalProperties';
export var ROOT_SCHEMA_PREFIX = '__rjsf_rootSchema';
export var UI_FIELD_KEY = 'ui:field';
export var UI_WIDGET_KEY = 'ui:widget';
export var UI_OPTIONS_KEY = 'ui:options';
export var UI_GLOBAL_OPTIONS_KEY = 'ui:globalOptions';